import { environment } from "@environments/environment";

export class ProductAsset {
  static getCantoSourceUrl(cantoId: string): string {
    return `${environment.cantoBaseUrl}/assets/${environment.cantoAccountId}/document_${cantoId}`;
  }
}
